import TfnView from './components/TfnView'
import useCanGoBack from '@/common/hooks/useCanGoBack'

export default function AccountTfnView() {
    const { goBackSafely } = useCanGoBack()

    return <TfnView onSave={goBackSafely} onCancel={goBackSafely} />
}
